module.exports = __webpack_public_path__ + "media/images/icons/ic-avatar-ba7add364e38ff10548ffafdfa3e8ef6.svg";